import { render, staticRenderFns } from "./InvestmentGenericLineGraph.vue?vue&type=template&id=b9ddfe94"
import script from "./InvestmentGenericLineGraph.vue?vue&type=script&lang=ts"
export * from "./InvestmentGenericLineGraph.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentGenericLineGraph.vue?vue&type=style&index=0&id=b9ddfe94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports